module.exports = __webpack_public_path__ + "static/media/18ECA7.10c1dbe5.jpg";